/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Layout_CuedInputs */



/**
* | output |
* | --- |
* | "Cued (one entry per event)" |
*
* @param {Transcript_Export_Layout_CuedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_layout_cued = /** @type {((inputs?: Transcript_Export_Layout_CuedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Layout_CuedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cued (one entry per event)")
	return /** @type {LocalizedString} */ ("Cued (one entry per event)")
});